import { useEffect, useState } from 'react'
import { StoreType } from 'types/store'
import { db } from 'firebase/index'

const useQueryAllStores = (): StoreType[] => {
  const [stores, setStores] = useState<StoreType[]>([])
  useEffect(() => {
    db.collection('stores')
      .orderBy('name_kana', 'asc')
      .get()
      .then((snapshots) => {
        const _stores: StoreType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as StoreType
          data.store_id = snapshot.id
          _stores.push(data)
        })
        setStores([..._stores])
      })
  }, [])
  return stores
}

export default useQueryAllStores
